const verifyDSDefaultState = {
    inputData: null,
    macPasses: "",
    verifyResultsArray: [],
    indexiesArray: [],
    withAuSigVerificationResultArray: [],
    showedObjectsArray: []
}

const verifyDSReducer = (state = verifyDSDefaultState, { type, payload }) => {

    switch (type) {

        case "SET_VERIFY_INPUT_DATA":
            return {
                ...state,
                inputData: payload
            }

        case "SET_MAC_PASSES":
            return {
                ...state,
                macPasses: payload
            }

        case "SET_VERIFY_RESULTS_ARRAY":
            return {
                ...state,
                verifyResultsArray: payload
            }

        case "SET_INDEXIES_ARRAY":
            return {
                ...state,
                indexiesArray: payload
            }

        case "SET_WITH_AUSIG_VERIFICATION_RESULT_ARRAY":
            return {
                ...state,
                withAuSigVerificationResultArray: payload
            }

        case "SET_SHOWED_OBJECTS_ARRAY":
            return {
                ...state,
                showedObjectsArray: payload
            }

        default:
            return state;
    }

}

export default verifyDSReducer